module.exports = "/images/vendor/flag-icon-css/flags/4x3/lk.svg?497ee5b9544ffc29720476b7085f7503";